import { HttpHeaders,HttpClient,HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../app/shared/services/api.service';
import {environment} from '../../../environments/environment';
import { IGlobalSearchParam } from '../../shared/models/Global-Search.model';
import { ClaimsMaster } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ClaimsMasterService{
    constructor(
        private http: HttpClient,
        private apiService: ApiService
    ) { }

   
     /**
    * This method is used to get the search results of claims master
    * based on the parameters.
    *
    * @param  pageNo  current page number
    * @param  pageSize Number of records per page
    * @param  sortField field needed to sort
    * @param  sortOrder whether the sorting field is ascending or descending
    * @param  appliedFilters appliedFilters
    * @return      json result
    */
      public searchClaimsMaster(pageNo:number,pageSize:number,sortField:string,sortOrder:string,appliedFilters:{field:string,matchMode:string,value:string}[]=[]):Observable<any> {
        return this.apiService.get(`ClaimsMaster/SearchClaimsMaster?pageNo=${pageNo}&pageSize=${pageSize}&sortField=${sortField}&sortOrder=${sortOrder}&appliedFilters=${appliedFilters}`)
      }
  
  
      /**
      * This method is used to get all claims master records, there is no parameter
      *
      * @return      json result
      */
       public getAllClaimsMasters(claimsMasterSearchParam:IGlobalSearchParam):Observable<any> {
        console.log(claimsMasterSearchParam);
        return this.apiService.post(`ClaimsMaster/SearchClaimsMaster`,claimsMasterSearchParam)
      }
  
      /**
      * This method is used to get individual claims master record based on the claimsid
      *
      * @param  claimsId  
      * @return      json result
      */
       public getClaimsMasterById(claimsId:number):Observable<any> {
          return this.apiService.get(`ClaimsMaster/${claimsId}`)
      }
  
      /**
      * This method is used to post/add new claims master record
      *
      * @param  ClaimsMaster object which contains the claims record values
      * @return      json result
      */
       public postClaimsMaster(claimsMaster:ClaimsMaster):Observable<any> {
          return this.apiService.post(`ClaimsMaster`, claimsMaster)
      }
  
  
      /**
      * This method is used to update the existing claims master record
      *
      * @param  Claims Id 
      * @param  ClaimsMaster object which contains the claims record values
      * @return      json result
      */
       public updateClaimsMaster(claimsId:number, claimsMaster:ClaimsMaster):Observable<any> {
          return this.apiService.put(`ClaimsMaster/${claimsId}`, claimsMaster)
      }
  
  
      /**
      * This method is used to delete the existing claims master record
      *
      * @param  Claims Id
      * @return      json result
      */
       public deleteClaimsMaster(claimsId:number):Observable<any> {
          return this.apiService.delete(`ClaimsMaster/${claimsId}`)
      }

      getFeatures():Observable<any>{
        return this.apiService.get(`applicationfeatures`)
      }

      getClaimTypeNotAddedForFeatureId(featureId: number):Observable<any>{
        return this.apiService.get(`ClaimsMaster/ClaimsNotAddedForFeatureId/${featureId}`)
      }

      public ExportClaimMasterResult(claimtSearchParam:IGlobalSearchParam):Observable<any> {
        return this.http.post(`${environment.apiRoot}ClaimsMaster/ExportClaimMaster`, claimtSearchParam,
        {  
            responseType: 'blob',
            observe: 'response'
         });
      }
  
}
